import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class NewDevice extends Component {

    constructor(props) {
        super(props);
        this.state  = {
            dataNewDevice: {
                box_id: '',
                device_no: '',
                imei: '',
                simNo: '',
                model: 'T333',
                network_operator: 'AIS',
                external_device: false
            }
        };
    }

    onClickBack = () => {
        const {onBack} = this.props;
        onBack();
    }


    render() {
        const {
            onSubmitNewDevice
        } = this.props;

        const { dataNewDevice } = this.state;
        return(

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <h5 className=""> <i class="fa fa-arrow-left" aria-hidden="true" style={{color: '#7386D5',cursor: 'pointer'}} onClick={this.onClickBack}></i> รายการตั้งค่าเครื่อง</h5>
                    </div>
                    <div className="card-body">
                        <h5>เพิ่มเครื่อง</h5>
                        <br />
                        <div className="row">
                        <div className="col-md-12">
                            <form>

                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">เลขกล่องเดิม</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="box_id"
                                            // defaultValue={userName}
                                            onChange={(e) => this.setState({ dataNewDevice : {...dataNewDevice, box_id: e.target.value }})}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">ทะเบียนรถ</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="device_no"
                                            // defaultValue={userName}
                                            onChange={(e) => this.setState({ dataNewDevice : {...dataNewDevice, device_no: e.target.value }})}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">imei</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="imei"
                                            // defaultValue={userName}
                                            onChange={(e) => this.setState({ dataNewDevice : {...dataNewDevice, imei: e.target.value }})}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">sim_no</label>
                                    <div className="col-md-10">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="sim_no"
                                            // defaultValue={userName}
                                            onChange={(e) => this.setState({ dataNewDevice : {...dataNewDevice, simNo: e.target.value }})}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">model</label>
                                    <div className="col-md-10">
                                        <select
                                            name="port"
                                            className="form-control"
                                            onChange={(e) => this.setState({ dataNewDevice : {...dataNewDevice, model: e.target.value }})}>
                                                <option id="t333" value="t333">T333</option>
                                                <option id="id5" value="id5">ID5</option>
                                                <option id="vt900" value="vt900">VT900</option>
                                                <option id="mvt340" value="mvt340">MVT340</option>
                                                <option id="mvt380" value="mvt348">MVT380</option>
                                                <option id="t1" value="t1">t1</option>
                                                <option id="t333g" value="t333g">T333G</option>
                                                <option id="fm1100" value="fm1100">FM1100</option>
                                        </select>

                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">Network Operator</label>
                                    <div className="col-md-10">
                                        <select
                                            name="network_operator"
                                            className="form-control"
                                            onChange={(e) => this.setState({ dataNewDevice : {...dataNewDevice, network_operator: e.target.value }})} >
                                                <option id="AIS" value="AIS">AIS</option>
                                                <option id="TRUE" value="TRUE">TRUE</option>
                                                <option id="DTAC" value="DTAC">DTAC</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 col-form-label">External device</label>
                                    <div className="col-md-10">
                                        <input
                                            name="external_device"
                                            type="checkbox"
                                            onChange={() => this.setState(prevState => ({ dataNewDevice : {...dataNewDevice, external_device: !prevState.dataNewDevice.external_device }}) )} >
                                        </input>
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>
                        <hr/>
                        <div className="text-right">
                        <button type="submit" className="btn btn-primary" onClick={() => onSubmitNewDevice(dataNewDevice)}>บันทึกข้อมูล</button>
                        </div>
                    </div>
                    </div>
                </div>
        );
    }
}
NewDevice.defaultProps = {

}

NewDevice.propTypes = {
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onCloseNewDevice: PropTypes.func.isRequired,
    onSubmitNewDevice: PropTypes.func.isRequired,
    onBack:PropTypes.func,
}


export default NewDevice;



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/NewDevice.js